<template>
  <layout-base id="gtr-emails-html">
    <div style="margin-top: 24px;">
      <table width="100%">
        <tr>
          <td align="center">
            <img :src="email.logo_url" style="width: 150px;" :alt="email.logo_url" />
          </td>
        </tr>
      </table>
    </div>
    <layout-block margin="24px 0">
      <!-- TITLE -->
      <layout-title :title="email.title" color="#000000" />
      <!-- Subtitle -->
      <div style="margin-top:12px; font-size: 14px; color: #A6B0C6;">{{ email.response_title }}</div>
    </layout-block>

    <layout-block margin="24px 0">
      <ui-message
        styleCustom="border-top-right-radius: 0px; width:50%; margin-left: auto;"
        bg-color="#A6B0C6"
        :message="email.comment"
      ></ui-message>
      <ui-message
        style="margin-top:14px;"
        styleCustom="border-bottom-left-radius: 0px; width:50%; margin-right: auto;"
        bg-color="#449AFD"
        :message="email.response"
      ></ui-message>
    </layout-block>

    <layout-block-separator style="margin: 30px 0;" />
    <!-- FOOTER -->
    <layout-block margin="32px 0 16px">
      <ui-logo :white="false" />
    </layout-block>
    <layout-block margin="16px 0">
      <internal-copyright />
    </layout-block>
    <layout-block margin="16px 0">
      <internal-social />
    </layout-block>
    <layout-block margin="16px 0 0">
      <ui-legend :label="$t('internal.footer')" font-size="10px" color="#53627c" margin="0" />
    </layout-block>
  </layout-base>
</template>

<script>
import LayoutBase from '@/components/Layout/Base.vue'
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutTitle from '@/components/Layout/Title.vue'
import InternalCopyright from '@/components/Internal/Copyright.vue'
import InternalSocial from '@/components/Internal/Social.vue'
import UiLegend from '@/components/UI/Legend.vue'
import UiLogo from '@/components/UI/Logo.vue'
import UiMessage from '@/components/UI/Message.vue'
import LayoutBlockSeparator from '@/components/Layout/Block/Separator.vue'

export default {
  components: {
    LayoutBase,
    LayoutBlock,
    LayoutTitle,
    InternalCopyright,
    InternalSocial,
    UiLegend,
    UiLogo,
    UiMessage,
    LayoutBlockSeparator,
  },
  props: {
    email: {
      type: Object,
      required: true,
    },
  },
}
</script>
